import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { ProductLabel } from "@/components/Product/Layout/ProductLabel/productLabel.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const WebOnly = () => {
    const { t } = useGranite();
    const { isWebOnly } = useECommerceProduct();

    if (!isWebOnly) {
        return null;
    }
    return <ProductLabel text={t("pricing.webOnly")} />;
};

export { WebOnly };
